<template>
<div>
  <div class="divSkeleton" v-if="!suggestions">
      <b-skeleton v-if="!suggestions" class="childSkeleton"></b-skeleton>
      <b-skeleton v-if="!suggestions" class="childSkeleton"></b-skeleton>
      <b-skeleton v-if="!suggestions" class="childSkeleton"></b-skeleton>
      <b-skeleton v-if="!suggestions" class="childSkeleton"></b-skeleton>
    </div>
    <section
    v-else
    class="special-products discounted-products container"
  >
    <div
      class="special-products-head d-flex justify-content-between mb-md-4 mb-3"
    >
      <div class="mt-1">
        <img src="@/assets/images/circle.png" alt="نونان" />
        <!-- <div class="circle1 rounded-circle mt-1 d-inline-block"></div> -->
        <h5 class="d-inline-block mr-1">
          <span class="weight-bold text-color-theme2">محصولات</span>
          <span class="text-color-theme fontsize14 font-weight-bolder">
            {{ this.title }}</span
          >
        </h5>
      </div>
      <div class="line mx-2 mt-3"></div>
      <div class="d-flex mt-1">
        <a class="position-relative arrow-circle rounded-circle d-block">
          <div class="swiper-button-next w-100 h-100"></div>
        </a>
        <a class="position-relative arrow-circle rounded-circle d-block mr-2">
          <div class="swiper-button-prev w-100 h-100"></div>
        </a>
      </div>
    </div>

    <div class="swiper-container py-3 mb-4">
      <div v-if="suggestions" class="swiper-wrapper">
        <div
          v-for="(product, index) in suggestions"
          :key="'suggestions' + index"
          class="swiper-slide bg-white discounted-products-item"
        >
          <SProduct :product="product"> </SProduct>
        </div>
      </div>
    </div>

    <router-link
      class="
        bg-color-theme2
        rounded
        py-2
        px-4
        fontsize-small
        font-weight-bold
        text-white
        d-table
        mx-auto
      "
      to="/products"
      >محصولات بیشتر</router-link
    >
  </section>
</div>

</template>

<script>
import SProduct from "@/parts/Front/components/product/SProduct.vue";
import Swiper from "swiper/swiper-bundle.min.js";
export default {
  name: "SpecialProducts",
  components: {
    SProduct,
  },
  props: {
    title: {
      default: "ویژه",
      type: String,
    },
  },
  methods: {
    widthResize() {
      const bodyWidth = document.body.offsetWidth;
      const specialProduct = document.querySelectorAll(
        ".special-products .swiper-slide .discounted-products-img"
      );
      const specialProductItems = document.querySelectorAll(
        ".special-products .swiper-slide"
      );
      for (let spItem of specialProduct) {
        spItem.style.height = spItem.offsetWidth / 1.14 + "px";
      }
      for (let spSlideItem of specialProductItems) {
        if (bodyWidth < 576 && bodyWidth > 460) {
          spSlideItem.style.minHeight = spSlideItem.offsetWidth / 0.8 + "px";
        } else if (bodyWidth < 460 && 420 < bodyWidth) {
          spSlideItem.style.minHeight = spSlideItem.offsetWidth / 0.72 + "px";
        } else if (bodyWidth < 421 && 384 < bodyWidth) {
          spSlideItem.style.minHeight = spSlideItem.offsetWidth / 0.68 + "px";
        } else if (bodyWidth < 385 && 298 < bodyWidth) {
          spSlideItem.style.minHeight = spSlideItem.offsetWidth / 0.65 + "px";
        } else if (bodyWidth < 299) {
          spSlideItem.style.minHeight = spSlideItem.offsetWidth / 0.8 + "px";
        } else {
          spSlideItem.style.minHeight = spSlideItem.offsetWidth / 0.75 + "px";
        }
      }
    },
    initSuggestionsSwiper(kill = false) {
      this.initSwiper("products-suggest-swiper", kill, () => {
        new Swiper(".special-products .swiper-container", {
          spaceBetween: 20,
          //   centeredSlides: true,
          loop: false,
          speed: 800,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: ".special-products .swiper-button-next",
            prevEl: ".special-products .swiper-button-prev",
          },
          breakpoints: {
            300: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            400: {
              slidesPerView:2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },

            992: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        });
      });
      //    this.$nextTick(() => {
      //   this.widthResize();
      // });
    },
  },
  mounted() {


    // window.addEventListener("resize", this.widthResize());
      this.initSuggestionsSwiper(true)
  },
  computed: {
    suggestions() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return null;
      } else {
        return this.$store.getters["front/getHomeData"].suggestions;
      }
    },
  },
  watch:{
    suggestions(val){
      if(val!=null){
       this.initSuggestionsSwiper(true);
      }
    }
  }
};
</script>

<style scoped>

</style>